import { LABEL_MAX_LENGTH } from '@shared/constants/textLimits';

// Single source of truth for schemaUrl and componentType
// Used by both admin and guest configs
export const CASH_FUND_COMPONENT_SCHEMA_URL = 'https://withjoy.com/assets/public/schemas/CashFundComponent_v2_0_2.json' as const;
export const CASH_FUND_V2_0_1_SCHEMA_URL = 'https://withjoy.com/assets/public/schemas/CashFundComponent_v2_0_1.json' as const;
export const CASH_FUND_COMPONENT_TYPE = 'CashFundComponent' as const;
export const CASH_FUND_BUTTON_LABEL_MAX_LENGTH = LABEL_MAX_LENGTH;
// v2_0_1 still validates buttonLabel against 50; every prod blob older than v2_0_2 is on v2_0_1.
export const CASH_FUND_LEGACY_BUTTON_LABEL_MAX_LENGTH = 50 as const;
